var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _g, _path114, _g2, _g3, _g4, _g5, _path115, _path116, _path117, _path118, _path119, _path120, _g6, _g7, _g8, _path121, _path122, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareerPathDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 546 394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcd009;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #cf4a0c;\n      }\n\n      .cls-4 {\n        fill: #002b54;\n      }\n\n      .cls-5 {\n        fill: #0a7cae;\n      }\n\n      .cls-6 {\n        fill: none;\n      }\n\n      .cls-7 {\n        fill: #f16829;\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-9 {\n        fill: #231f20;\n      }\n\n      .cls-10 {\n        isolation: isolate;\n      }\n\n      .cls-11 {\n        fill: #006d72;\n      }\n\n      .cls-12 {\n        fill: #0895d3;\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-15 {\n        fill: #584887;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 334,
    y: 335.43,
    width: 4.19,
    height: 47
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 439,
    y: 334.98,
    width: 4.19,
    height: 47
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 231,
    y: 334.98,
    width: 4.19,
    height: 47
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M495,291.97c26.47,0,48-21.53,48-48,0-18.94-11.03-35.35-27-43.15v-3.3c17.67,8.02,30,25.82,30,46.46,0,28.12-22.88,51-51,51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M494,202H53c-23.2,0-42,18.8-42,42s18.8,42,42,42h441c23.2,0,42-18.8,42-42s-18.8-42-42-42Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M283.94,80.96c.8,0,1.46-.66,1.46-1.46s-.66-1.46-1.46-1.46h-8.79v-.04h-2.91v.04h-8.79c-.8,0-1.46.66-1.46,1.46,0,.4.16.76.43,1.03.26.26.63.43,1.03.43h8.79v.04h2.91v-.04h8.79Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M263.46,75.04h5.79v-5.79c0-2.46,2-4.46,4.46-4.46s4.46,2,4.46,4.46v5.79h5.79c1.93,0,3.56,1.24,4.18,2.96h59.78c-1.05-39.94-33.73-72-73.93-72s-72.88,32.06-73.93,72h59.23c.62-1.72,2.25-2.96,4.18-2.96Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M288.12,81c-.62,1.72-2.25,2.96-4.18,2.96h-5.79v5.79c0,2.46-2,4.46-4.46,4.46-1.19,0-2.31-.46-3.15-1.31-.84-.84-1.31-1.96-1.31-3.15v-5.79h-5.79c-1.19,0-2.31-.46-3.15-1.31-.47-.47-.81-1.04-1.03-1.65h-59.25c.05,3.47.31,6.88.82,10.21.03.21.08.42.11.64.16.99.33,1.98.53,2.96.1.51.23,1.02.35,1.53.15.67.29,1.35.47,2.02.22.85.47,1.7.72,2.54.09.32.17.64.27.96.72,2.34,1.57,4.65,2.53,6.91.11.26.23.52.35.78.29.67.59,1.33.9,1.99.21.45.44.9.66,1.35.25.5.51,1,.77,1.5.24.45.47.9.72,1.34.33.6.68,1.19,1.03,1.78.32.55.65,1.09.99,1.63.37.59.74,1.17,1.12,1.75.25.38.51.75.77,1.12.37.53.74,1.06,1.12,1.58.24.33.49.67.74,1,.59.78,1.18,1.54,1.8,2.29.14.17.28.33.42.49.57.69,1.16,1.37,1.76,2.03.24.26.48.52.72.78.51.55,1.03,1.1,1.56,1.63.24.24.47.48.71.72.74.74,1.5,1.46,2.27,2.17.08.07.17.15.25.22.7.63,1.42,1.25,2.15,1.86.28.24.57.47.86.7.55.44,1.11.88,1.67,1.31.31.24.63.48.95.72.67.49,1.34.97,2.02,1.44.17.12.34.24.51.36.13.09.26.17.4.26.7.47,1.42.92,2.14,1.37.3.19.61.37.91.56.82.49,1.65.97,2.49,1.43.21.12.43.22.64.34.72.39,1.46.76,2.19,1.12.3.15.6.29.9.44.89.42,1.78.83,2.68,1.21.23.1.47.19.7.29.79.33,1.59.65,2.4.95.23.09.46.18.7.26.98.36,1.97.69,2.97,1.01.19.06.38.12.57.17,2.21.67,4.45,1.26,6.74,1.72h.03c4.81.99,9.79,1.51,14.9,1.51,6.35,0,12.52-.8,18.4-2.31.08-.02.16-.04.23-.06,1.08-.28,2.14-.58,3.2-.91.07-.02.15-.04.22-.07,1.01-.32,2.01-.66,3-1.02.27-.1.54-.2.82-.3.88-.33,1.75-.67,2.61-1.03.1-.04.21-.08.31-.13.15-.07.31-.14.46-.2.8-.34,1.58-.7,2.37-1.07.4-.19.79-.38,1.18-.58.58-.29,1.15-.58,1.72-.88.39-.2.77-.41,1.16-.62.76-.42,1.52-.85,2.26-1.3.3-.18.6-.36.9-.55.73-.45,1.44-.91,2.15-1.38.31-.21.61-.42.92-.63.62-.43,1.23-.86,1.84-1.31.26-.19.52-.38.78-.58,1.72-1.3,3.38-2.67,4.98-4.11.19-.17.38-.35.56-.52.65-.6,1.29-1.2,1.91-1.82.16-.16.33-.32.49-.48,1.54-1.55,3.01-3.17,4.41-4.85.16-.2.33-.4.49-.6.54-.66,1.06-1.33,1.58-2.01.17-.22.34-.44.5-.66,1.29-1.74,2.51-3.54,3.64-5.4.15-.25.3-.5.45-.75.42-.7.83-1.42,1.23-2.14.15-.27.3-.55.45-.82.44-.82.86-1.65,1.27-2.49.07-.14.15-.29.22-.43.47-.98.92-1.98,1.35-2.99.1-.24.2-.49.3-.74.32-.77.63-1.55.92-2.34.12-.31.23-.62.34-.94.3-.84.59-1.68.86-2.53.06-.2.13-.39.19-.59.33-1.06.63-2.13.91-3.21.05-.2.1-.4.15-.6.23-.91.44-1.82.63-2.74.05-.25.1-.5.15-.75.21-1.08.41-2.16.58-3.25,0-.02,0-.04,0-.05.18-1.18.33-2.38.45-3.58.01-.12.02-.24.03-.36.1-1.05.18-2.11.24-3.17.01-.2.02-.39.03-.59.04-.84.05-1.69.06-2.54h-59.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M219.66,130.18c-.24-.26-.48-.52-.72-.78.24.26.48.52.72.78Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M221.93,132.54c-.24-.24-.47-.48-.71-.72.24.24.47.48.71.72Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M217.18,127.37c-.14-.17-.28-.33-.42-.49.14.17.28.33.42.49Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M224.45,134.93c-.08-.07-.17-.15-.25-.22.08.07.17.15.25.22Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M239.2,145.27c-.21-.11-.43-.22-.64-.34.21.12.43.22.64.34Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M236.06,143.5c-.31-.18-.61-.37-.91-.56.3.19.61.37.91.56Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M227.46,137.49c-.29-.23-.58-.47-.86-.7.28.24.57.47.86.7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M230.08,139.52c-.32-.24-.63-.48-.95-.72.31.24.63.48.95.72Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M214.97,124.58c-.25-.33-.49-.67-.74-1,.24.33.49.67.74,1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M213.11,122.01c-.26-.37-.51-.74-.77-1.12.25.38.51.75.77,1.12Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M200.96,91.85c-.03-.21-.08-.42-.11-.64.03.21.08.42.11.64Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M203.02,100.9c-.25-.84-.5-1.69-.72-2.54.22.86.47,1.7.72,2.54Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M201.84,96.34c-.12-.51-.24-1.02-.35-1.53.1.51.23,1.02.35,1.53Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M211.22,119.14c-.34-.54-.67-1.08-.99-1.63.32.55.65,1.09.99,1.63Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M209.21,115.72c-.24-.44-.48-.89-.72-1.34.24.45.47.9.72,1.34Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M207.72,112.88c-.22-.45-.45-.9-.66-1.35.21.45.44.9.66,1.35Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M333.44,123.98c-.17.22-.34.44-.5.66.17-.22.34-.44.5-.66Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M312.81,142.94c-.3.18-.6.37-.9.55.3-.18.6-.36.9-.55Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M242.29,146.83c-.3-.14-.6-.29-.9-.44.3.15.6.29.9.44Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M318.51,139.05c-.26.2-.52.39-.78.58.26-.19.52-.38.78-.58Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M309.65,144.79c-.38.21-.77.41-1.16.62.39-.2.77-.41,1.16-.62Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M331.36,126.66c-.16.2-.32.4-.49.6.16-.2.33-.4.49-.6Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M324.05,134.42c-.19.17-.38.35-.56.52.19-.17.38-.35.56-.52Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M306.78,146.28c-.39.19-.79.39-1.18.58.4-.19.79-.38,1.18-.58Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M326.46,132.11c-.16.16-.33.32-.49.48.16-.16.33-.32.49-.48Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M315.89,140.93c-.31.21-.61.42-.92.63.31-.21.61-.42.92-.63Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M248.77,149.54c-.23-.08-.46-.17-.7-.26.23.09.46.18.7.26Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M245.68,148.34c-.23-.1-.47-.19-.7-.29.23.1.47.19.7.29Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M292.61,151.58c-.08.02-.16.04-.23.06.08-.02.16-.04.23-.06Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M259.08,152.45h-.03s.02,0,.03,0Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M296.03,150.61c-.07.02-.15.04-.22.07.07-.02.15-.04.22-.07Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M299.85,149.29c-.27.1-.54.2-.82.3.27-.1.54-.2.82-.3Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M252.31,150.72c-.19-.06-.38-.11-.57-.17.19.06.38.12.57.17Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M343.62,104.96c-.11.31-.23.62-.34.94.12-.31.23-.62.34-.94Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M340.7,111.96c-.07.15-.15.29-.22.43.07-.14.15-.29.22-.43Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M342.35,108.24c-.1.25-.2.49-.3.74.1-.24.2-.49.3-.74Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M344.67,101.84c-.06.2-.13.39-.19.59.06-.2.13-.39.19-.59Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M346.51,94.54c-.05.25-.1.5-.15.75.05-.25.1-.5.15-.75Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M345.72,98.03c-.05.2-.1.4-.15.6.05-.2.1-.4.15-.6Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M302.46,148.26c.26-.11.51-.22.77-.33-.15.07-.31.14-.46.2-.1.04-.21.08-.31.13Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M337.08,118.59c.15-.25.3-.5.45-.75-.15.25-.3.5-.45.75Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M339.21,114.88c-.15.28-.3.55-.45.82.15-.27.3-.55.45-.82Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M203.29,101.86c.81,2.63,1.78,5.19,2.87,7.69-.11-.26-.24-.52-.35-.78-.96-2.26-1.8-4.57-2.53-6.91Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M232.1,140.96c.3.21.6.42.91.62-.13-.09-.26-.17-.4-.26-.17-.12-.34-.24-.51-.36Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M347.59,87.3c-.01.12-.02.24-.03.36.01-.12.02-.24.03-.36Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M347.1,91.23s0,.04,0,.05c0-.02,0-.04,0-.05Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M347.86,83.54c0,.2-.02.39-.03.59.01-.2.02-.39.03-.59Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M248.08,149.28c-.81-.3-1.61-.62-2.4-.95.8.33,1.6.65,2.4.95Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M299.03,149.59c-.99.36-1.99.7-3,1.02,1.01-.31,2-.66,3-1.02Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M332.93,124.65c-.51.68-1.04,1.35-1.58,2.01.54-.66,1.06-1.33,1.58-2.01Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M338.76,115.7c-.4.72-.81,1.43-1.23,2.14.42-.71.83-1.42,1.23-2.14Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M305.6,146.86c-.78.37-1.57.73-2.37,1.07.8-.34,1.58-.7,2.37-1.07Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M302.46,148.26c-.86.36-1.73.7-2.61,1.03.87-.33,1.75-.67,2.61-1.03Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M259.05,152.45c-2.29-.47-4.53-1.05-6.74-1.72,2.22.68,4.47,1.26,6.74,1.72Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M347.86,83.54c.04-.84.06-1.69.07-2.54h0c-.01.85-.02,1.7-.06,2.54Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M308.5,145.4c-.57.3-1.14.59-1.72.88.58-.29,1.15-.58,1.72-.88Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M335.32,121.34c.61-.9,1.19-1.82,1.76-2.75-1.14,1.85-2.35,3.65-3.64,5.4.64-.87,1.28-1.75,1.88-2.65Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M347.83,84.12c-.06,1.06-.14,2.12-.24,3.17.1-1.05.18-2.11.24-3.17Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M295.81,150.67c-1.06.33-2.12.63-3.2.91,1.07-.28,2.14-.58,3.2-.91Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M259.08,152.45c10.94,2.25,22.34,2.01,33.3-.81-5.88,1.51-12.05,2.31-18.4,2.31-5.1,0-10.08-.52-14.9-1.5Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M323.49,134.93c-1.6,1.44-3.26,2.81-4.98,4.11,1.72-1.3,3.38-2.67,4.98-4.11Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M325.96,132.59c-.63.62-1.26,1.23-1.91,1.82.65-.6,1.29-1.2,1.91-1.82Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M330.87,127.26c-1.4,1.68-2.87,3.3-4.41,4.85,1.54-1.55,3.01-3.17,4.41-4.85Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M201.49,94.81c-.2-.98-.37-1.97-.53-2.96.16.99.33,1.98.53,2.96Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M311.91,143.49c-.75.45-1.5.88-2.26,1.3.76-.42,1.51-.85,2.26-1.3Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M317.72,139.62c-.61.45-1.22.88-1.84,1.31.62-.43,1.23-.86,1.84-1.31Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M200.02,81c.04,3.43.31,6.84.82,10.21-.51-3.33-.78-6.75-.82-10.21h0Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M210.23,117.51c-.35-.59-.69-1.18-1.03-1.78.33.6.68,1.19,1.03,1.78Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M202.3,98.36c-.17-.67-.31-1.34-.47-2.02.15.67.29,1.35.47,2.02Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M314.97,141.56c-.71.47-1.43.93-2.15,1.38.73-.45,1.44-.91,2.15-1.38Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M251.74,150.55c-1-.31-1.99-.65-2.97-1.01.98.36,1.97.69,2.97,1.01Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M218.94,129.4c-.6-.67-1.19-1.34-1.76-2.03.57.69,1.16,1.36,1.76,2.03Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M344.47,102.43c-.27.85-.56,1.7-.86,2.53.3-.84.59-1.68.86-2.53Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M208.49,114.38c-.26-.5-.52-1-.77-1.5.25.5.51,1,.77,1.5Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M347.56,87.65c-.12,1.2-.27,2.39-.45,3.58.18-1.19.33-2.38.45-3.58Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M224.2,134.7c-.78-.71-1.53-1.43-2.27-2.17.74.74,1.5,1.46,2.27,2.17Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M226.6,136.78c-.73-.61-1.44-1.22-2.15-1.86.7.63,1.42,1.25,2.15,1.86Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M221.22,131.82c-.53-.54-1.05-1.08-1.56-1.63.51.55,1.03,1.1,1.56,1.63Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M346.36,95.29c-.19.92-.41,1.83-.63,2.74.23-.91.44-1.82.63-2.74Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M214.23,123.58c-.38-.52-.75-1.05-1.12-1.58.37.53.74,1.06,1.12,1.58Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M212.34,120.89c-.38-.58-.75-1.16-1.12-1.75.37.59.74,1.17,1.12,1.75Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M216.77,126.87c-.62-.75-1.21-1.52-1.8-2.29.59.78,1.18,1.54,1.8,2.29Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M347.09,91.29c-.17,1.09-.37,2.18-.58,3.25.22-1.08.41-2.16.58-3.25Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M345.58,98.63c-.28,1.08-.58,2.15-.91,3.21.33-1.06.63-2.13.91-3.21Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M343.27,105.9c-.29.79-.6,1.57-.92,2.34.32-.77.63-1.55.92-2.34Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M342.05,108.98c-.43,1.01-.88,2-1.35,2.99.47-.99.92-1.98,1.35-2.99Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M235.15,142.94c-.72-.45-1.43-.9-2.14-1.37.71.47,1.42.93,2.14,1.37Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M203.29,101.86c-.1-.32-.18-.64-.27-.96.09.32.17.64.27.96Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M238.56,144.93c-.84-.46-1.67-.94-2.49-1.43.82.49,1.65.98,2.49,1.43Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M241.39,146.4c-.74-.36-1.47-.74-2.19-1.12.73.39,1.46.76,2.19,1.12Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M340.48,112.39c-.41.84-.83,1.67-1.27,2.49.44-.82.86-1.65,1.27-2.49Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M232.1,140.96c-.68-.47-1.36-.95-2.02-1.44.67.49,1.34.97,2.02,1.44Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M229.13,138.8c-.56-.43-1.12-.87-1.67-1.31.55.44,1.11.88,1.67,1.31Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M488,222h-100c-12.13,0-22,9.87-22,22s9.87,22,22,22h100c12.13,0,22-9.87,22-22s-9.87-22-22-22Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M207.06,111.53c-.31-.66-.61-1.32-.9-1.99.29.67.59,1.33.9,1.99Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M244.97,148.05c-.9-.39-1.8-.79-2.68-1.21.89.42,1.78.83,2.68,1.21Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M386.89,249h-2.41l-.7-2.18h-3.49l-.69,2.18h-2.39l3.57-9.8h2.62l3.49,9.8ZM383.28,245.12l-1.05-3.29c-.08-.25-.13-.54-.16-.88h-.05c-.02.29-.08.57-.17.85l-1.07,3.32h2.51Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M388.4,249v-9.8h3.47c3.48,0,5.22,1.59,5.22,4.78,0,1.53-.47,2.75-1.42,3.66s-2.22,1.37-3.8,1.37h-3.47ZM390.6,241v6.21h1.09c.96,0,1.71-.29,2.25-.86.54-.57.82-1.36.82-2.34,0-.93-.27-1.67-.81-2.2-.54-.54-1.3-.8-2.27-.8h-1.08Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M407.16,239.2l-3.38,9.8h-2.5l-3.34-9.8h2.38l2.04,6.82c.11.37.18.7.2.98h.04c.03-.31.1-.64.21-1l2.03-6.79h2.31Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M416.51,249h-2.41l-.7-2.18h-3.49l-.69,2.18h-2.39l3.57-9.8h2.62l3.49,9.8ZM412.9,245.12l-1.05-3.29c-.08-.25-.13-.54-.16-.88h-.05c-.02.29-.08.57-.17.85l-1.07,3.32h2.51Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M426.83,249h-2.23l-4.04-6.16c-.24-.36-.4-.63-.49-.81h-.03c.04.35.05.88.05,1.59v5.39h-2.08v-9.8h2.38l3.89,5.97c.18.27.34.54.49.8h.03c-.04-.23-.05-.68-.05-1.35v-5.42h2.08v9.8Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M436.38,248.65c-.71.35-1.65.52-2.8.52-1.5,0-2.69-.44-3.55-1.33s-1.29-2.06-1.29-3.53c0-1.57.48-2.84,1.45-3.81.97-.98,2.22-1.46,3.77-1.46.96,0,1.76.12,2.42.36v2.13c-.66-.39-1.4-.59-2.24-.59-.92,0-1.66.29-2.23.87-.56.58-.85,1.36-.85,2.35s.27,1.7.8,2.27c.53.56,1.25.84,2.15.84s1.65-.21,2.37-.63v2.02Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M444.25,249h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M446.1,249v-9.8h3.47c3.48,0,5.22,1.59,5.22,4.78,0,1.53-.48,2.75-1.43,3.66s-2.22,1.37-3.8,1.37h-3.47ZM448.31,241v6.21h1.09c.96,0,1.71-.29,2.25-.86.54-.57.82-1.36.82-2.34,0-.93-.27-1.67-.81-2.2-.54-.54-1.3-.8-2.27-.8h-1.08Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M466.69,249h-5.84v-9.8h2.21v8.01h3.63v1.79Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M474.16,249h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M484.25,239.2l-3.38,9.8h-2.5l-3.34-9.8h2.38l2.04,6.82c.11.37.17.7.2.98h.04c.03-.31.1-.64.21-1l2.03-6.79h2.31Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M491.58,249h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M499.27,249h-5.84v-9.8h2.21v8.01h3.63v1.79Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M322,222h-100c-12.13,0-22,9.87-22,22s9.87,22,22,22h100c12.13,0,22-9.87,22-22s-9.87-22-22-22Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mID_lEVEL",
    "data-name": "mID lEVEL",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M247.85,249h-2.18v-5.87c0-.63.03-1.33.08-2.1h-.05c-.11.6-.22,1.03-.31,1.3l-2.3,6.67h-1.8l-2.34-6.6c-.06-.18-.17-.63-.31-1.37h-.06c.06.97.09,1.81.09,2.54v5.42h-1.99v-9.8h3.23l2,5.81c.16.46.28.93.35,1.4h.04c.12-.54.25-1.01.39-1.42l2-5.8h3.15v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M252.57,249h-2.21v-9.8h2.21v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M255.08,249v-9.8h3.47c3.48,0,5.22,1.59,5.22,4.78,0,1.53-.48,2.75-1.43,3.66s-2.22,1.37-3.8,1.37h-3.47ZM257.28,241v6.21h1.09c.96,0,1.71-.29,2.25-.86s.82-1.36.82-2.34c0-.93-.27-1.67-.81-2.2-.54-.54-1.3-.8-2.27-.8h-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M275.66,249h-5.84v-9.8h2.21v8.01h3.63v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M283.14,249h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M293.22,239.2l-3.38,9.8h-2.5l-3.34-9.8h2.38l2.04,6.82c.11.37.17.7.2.98h.04c.03-.31.1-.64.21-1l2.03-6.79h2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M300.55,249h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M308.24,249h-5.84v-9.8h2.21v8.01h3.63v1.79Z"
  })))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158,222H58c-12.13,0-22,9.87-22,22s9.87,22,22,22h100c12.13,0,22-9.87,22-22s-9.87-22-22-22Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ion-md-arrow-round-forward",
    "data-name": "Icon ion-md-arrow-round-forward",
    className: "cls-2",
    d: "M265.49,173.26l7.07,7.28c.31.31.74.49,1.18.48h.02c.44.01.87-.16,1.18-.48l7.07-7.28c.63-.59.66-1.58.07-2.2-.02-.03-.05-.05-.07-.07-.67-.63-1.71-.63-2.38,0l-4.19,4.38v-15.29c-.03-.93-.81-1.66-1.74-1.63-.89.03-1.6.74-1.63,1.63v15.29l-4.18-4.38c-.67-.63-1.71-.63-2.38,0-.63.59-.66,1.58-.07,2.21.02.02.05.05.07.07Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cORE_bUSINESS_sKILLS",
    "data-name": "cORE bUSINESS sKILLS",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.26,26.93c-.72.35-1.65.52-2.8.52-1.5,0-2.69-.44-3.55-1.33s-1.29-2.06-1.29-3.53c0-1.57.48-2.84,1.45-3.81s2.23-1.46,3.77-1.46c.96,0,1.76.12,2.42.36v2.13c-.66-.39-1.4-.59-2.24-.59-.92,0-1.66.29-2.23.87s-.85,1.36-.85,2.35.27,1.7.8,2.27c.53.56,1.25.84,2.15.84s1.65-.21,2.37-.63v2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M269.22,27.45c-1.4,0-2.55-.46-3.43-1.37-.88-.91-1.33-2.1-1.33-3.57,0-1.55.45-2.8,1.35-3.76s2.09-1.44,3.57-1.44c1.4,0,2.53.46,3.39,1.37s1.3,2.12,1.3,3.62-.45,2.78-1.34,3.73c-.9.94-2.06,1.42-3.5,1.42ZM269.31,19.21c-.77,0-1.39.29-1.85.87-.46.58-.68,1.35-.68,2.31s.23,1.74.68,2.3,1.05.85,1.79.85,1.36-.27,1.81-.82c.45-.55.67-1.31.67-2.29s-.22-1.81-.65-2.37-1.03-.85-1.78-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.19,27.28h-2.54l-1.52-2.52c-.11-.19-.22-.36-.33-.51-.1-.15-.21-.28-.32-.39-.11-.11-.22-.19-.33-.25-.12-.06-.24-.08-.38-.08h-.59v3.75h-2.21v-9.8h3.5c2.38,0,3.57.89,3.57,2.67,0,.34-.05.66-.16.95-.1.29-.25.55-.44.78s-.42.43-.69.6c-.27.17-.57.3-.91.4v.03c.15.05.29.12.42.22.14.1.27.22.4.36.13.14.25.28.37.44.12.16.22.31.32.46l1.85,2.9ZM278.18,19.13v2.73h.96c.47,0,.85-.14,1.14-.41.29-.28.44-.62.44-1.03,0-.86-.51-1.29-1.54-1.29h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.27,27.28h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.76,43.28v-9.8h3.57c1.09,0,1.93.2,2.52.6s.88.97.88,1.7c0,.53-.18.99-.54,1.39s-.81.67-1.37.83v.03c.7.09,1.25.34,1.67.77s.63.95.63,1.57c0,.9-.32,1.61-.96,2.14-.64.53-1.52.79-2.63.79h-3.77ZM242.97,35.1v2.32h.97c.46,0,.81-.11,1.08-.33.26-.22.39-.52.39-.91,0-.72-.54-1.08-1.61-1.08h-.83ZM242.97,39.07v2.58h1.2c.51,0,.91-.12,1.2-.36s.43-.56.43-.97-.14-.7-.43-.92-.68-.33-1.19-.33h-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M258.01,39.03c0,2.94-1.37,4.42-4.12,4.42s-3.99-1.44-3.99-4.31v-5.66h2.21v5.69c0,1.59.62,2.38,1.86,2.38s1.83-.77,1.83-2.3v-5.77h2.21v5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.97,42.9v-2.19c.4.33.83.58,1.29.75.46.17.93.25,1.41.25.28,0,.52-.03.73-.08s.38-.12.52-.21c.14-.09.24-.19.31-.31.07-.12.1-.25.1-.39,0-.19-.05-.36-.16-.51s-.26-.29-.45-.42-.41-.25-.67-.37-.54-.24-.84-.36c-.77-.32-1.34-.71-1.71-1.17s-.56-1.02-.56-1.67c0-.51.1-.95.31-1.32.21-.37.48-.67.84-.91s.76-.41,1.23-.52c.46-.11.96-.17,1.48-.17s.96.03,1.36.09c.39.06.76.16,1.09.28v2.04c-.16-.11-.34-.21-.54-.3s-.39-.16-.6-.21c-.21-.06-.41-.1-.61-.13s-.4-.04-.58-.04c-.25,0-.48.02-.68.07-.21.05-.38.11-.52.2s-.25.19-.33.31c-.08.12-.12.26-.12.41,0,.16.04.31.13.44.09.13.21.25.37.37.16.12.35.23.58.34.23.11.49.23.77.35.39.16.74.34,1.06.52.31.18.58.39.8.62s.39.5.51.8c.12.3.18.65.18,1.04,0,.55-.1,1.01-.31,1.38-.21.37-.49.67-.84.9-.36.23-.77.39-1.24.5s-.97.15-1.49.15-1.05-.05-1.53-.14-.91-.23-1.26-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270.75,43.28h-2.21v-9.8h2.21v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.08,43.28h-2.23l-4.04-6.16c-.24-.36-.4-.63-.49-.81h-.03c.04.35.05.88.05,1.59v5.39h-2.08v-9.8h2.38l3.89,5.97c.18.27.34.54.49.8h.03c-.04-.23-.05-.68-.05-1.35v-5.42h2.08v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.48,43.28h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.88,42.9v-2.19c.4.33.83.58,1.29.75.46.17.93.25,1.41.25.28,0,.52-.03.73-.08.21-.05.38-.12.52-.21.14-.09.24-.19.31-.31.07-.12.1-.25.1-.39,0-.19-.05-.36-.16-.51s-.26-.29-.45-.42c-.19-.13-.41-.25-.67-.37s-.54-.24-.84-.36c-.77-.32-1.34-.71-1.71-1.17s-.56-1.02-.56-1.67c0-.51.1-.95.31-1.32.21-.37.48-.67.84-.91.35-.24.76-.41,1.23-.52.46-.11.96-.17,1.48-.17s.96.03,1.36.09c.39.06.76.16,1.09.28v2.04c-.16-.11-.34-.21-.54-.3-.19-.09-.39-.16-.6-.21-.21-.06-.41-.1-.61-.13-.2-.03-.4-.04-.58-.04-.25,0-.48.02-.68.07-.21.05-.38.11-.52.2-.14.09-.25.19-.33.31-.08.12-.12.26-.12.41,0,.16.04.31.13.44.09.13.21.25.37.37.16.12.35.23.58.34.23.11.49.23.77.35.39.16.74.34,1.06.52.31.18.58.39.8.62.22.23.39.5.51.8.12.3.18.65.18,1.04,0,.55-.1,1.01-.31,1.38-.21.37-.49.67-.84.9-.36.23-.77.39-1.24.5s-.97.15-1.49.15-1.05-.05-1.54-.14-.91-.23-1.26-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.01,42.9v-2.19c.4.33.83.58,1.29.75.46.17.93.25,1.41.25.28,0,.52-.03.73-.08.21-.05.38-.12.52-.21.14-.09.24-.19.31-.31.07-.12.1-.25.1-.39,0-.19-.05-.36-.16-.51s-.26-.29-.45-.42c-.19-.13-.41-.25-.67-.37s-.54-.24-.84-.36c-.77-.32-1.34-.71-1.71-1.17s-.56-1.02-.56-1.67c0-.51.1-.95.31-1.32.21-.37.48-.67.84-.91.35-.24.76-.41,1.23-.52.46-.11.96-.17,1.48-.17s.96.03,1.36.09c.39.06.76.16,1.09.28v2.04c-.16-.11-.34-.21-.54-.3-.19-.09-.39-.16-.6-.21-.21-.06-.41-.1-.61-.13-.2-.03-.4-.04-.58-.04-.25,0-.48.02-.68.07-.21.05-.38.11-.52.2-.14.09-.25.19-.33.31-.08.12-.12.26-.12.41,0,.16.04.31.13.44.09.13.21.25.37.37.16.12.35.23.58.34.23.11.49.23.77.35.39.16.74.34,1.06.52.31.18.58.39.8.62.22.23.39.5.51.8.12.3.18.65.18,1.04,0,.55-.1,1.01-.31,1.38-.21.37-.49.67-.84.9-.36.23-.77.39-1.24.5s-.97.15-1.49.15-1.05-.05-1.53-.14-.91-.23-1.26-.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.62,58.9v-2.19c.4.33.83.58,1.29.75.46.17.93.25,1.41.25.28,0,.52-.03.73-.08s.38-.12.52-.21c.14-.09.24-.19.31-.31.07-.12.1-.25.1-.39,0-.19-.05-.36-.16-.51s-.26-.29-.45-.42-.41-.25-.67-.37-.54-.24-.84-.36c-.77-.32-1.34-.71-1.71-1.17s-.56-1.02-.56-1.67c0-.51.1-.95.31-1.32.21-.37.48-.67.84-.91s.76-.41,1.23-.52c.46-.11.96-.17,1.48-.17s.96.03,1.36.09c.39.06.76.16,1.09.28v2.04c-.16-.11-.34-.21-.54-.3s-.39-.16-.6-.21c-.21-.06-.41-.1-.61-.13s-.4-.04-.58-.04c-.25,0-.48.02-.68.07-.21.05-.38.11-.52.2s-.25.19-.33.31c-.08.12-.12.26-.12.41,0,.16.04.31.13.44.09.13.21.25.37.37.16.12.35.23.58.34.23.11.49.23.77.35.39.16.74.34,1.06.52.31.18.58.39.8.62s.39.5.51.8c.12.3.18.65.18,1.04,0,.55-.1,1.01-.31,1.38-.21.37-.49.67-.84.9-.36.23-.77.39-1.24.5s-.97.15-1.49.15-1.05-.05-1.53-.14-.91-.23-1.26-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.34,59.28h-2.79l-2.86-4.26c-.05-.08-.14-.26-.26-.54h-.03v4.8h-2.21v-9.8h2.21v4.63h.03c.05-.13.15-.31.27-.55l2.71-4.09h2.63l-3.42,4.68,3.71,5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.77,59.28h-2.21v-9.8h2.21v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.12,59.28h-5.84v-9.8h2.21v8.01h3.63v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.55,59.28h-5.84v-9.8h2.21v8.01h3.63v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.7,58.9v-2.19c.4.33.83.58,1.29.75.46.17.93.25,1.41.25.28,0,.52-.03.73-.08.21-.05.38-.12.52-.21.14-.09.24-.19.31-.31.07-.12.1-.25.1-.39,0-.19-.05-.36-.16-.51s-.26-.29-.45-.42c-.19-.13-.41-.25-.67-.37s-.54-.24-.84-.36c-.77-.32-1.34-.71-1.71-1.17s-.56-1.02-.56-1.67c0-.51.1-.95.31-1.32.21-.37.48-.67.84-.91.35-.24.76-.41,1.23-.52.46-.11.96-.17,1.48-.17s.96.03,1.36.09c.39.06.76.16,1.09.28v2.04c-.16-.11-.34-.21-.54-.3-.19-.09-.39-.16-.6-.21-.21-.06-.41-.1-.61-.13-.2-.03-.4-.04-.58-.04-.25,0-.48.02-.68.07-.21.05-.38.11-.52.2-.14.09-.25.19-.33.31-.08.12-.12.26-.12.41,0,.16.04.31.13.44.09.13.21.25.37.37.16.12.35.23.58.34.23.11.49.23.77.35.39.16.74.34,1.06.52.31.18.58.39.8.62.22.23.39.5.51.8.12.3.18.65.18,1.04,0,.55-.1,1.01-.31,1.38-.21.37-.49.67-.84.9-.36.23-.77.39-1.24.5s-.97.15-1.49.15-1.05-.05-1.53-.14-.91-.23-1.26-.41Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "discipline_specific_skills",
    "data-name": "discipline specific skills",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.03,110.86v-9.8h3.47c3.48,0,5.22,1.59,5.22,4.78,0,1.53-.48,2.75-1.43,3.66s-2.22,1.37-3.8,1.37h-3.47ZM238.24,102.85v6.21h1.09c.96,0,1.71-.29,2.25-.86s.82-1.36.82-2.34c0-.93-.27-1.67-.81-2.2-.54-.54-1.3-.8-2.27-.8h-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.84,110.86h-2.21v-9.8h2.21v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.9,110.48v-2.19c.4.33.83.58,1.29.75.46.17.93.25,1.41.25.28,0,.52-.03.73-.08s.38-.12.52-.21c.14-.09.24-.19.31-.31.07-.12.1-.25.1-.39,0-.19-.05-.36-.16-.51s-.26-.29-.45-.42-.41-.25-.67-.37-.54-.24-.84-.36c-.77-.32-1.34-.71-1.71-1.17s-.56-1.02-.56-1.67c0-.51.1-.95.31-1.32.21-.37.48-.67.84-.91s.76-.41,1.23-.52c.46-.11.96-.17,1.48-.17s.96.03,1.36.09c.39.06.76.16,1.09.28v2.04c-.16-.11-.34-.21-.54-.3s-.39-.16-.6-.21c-.21-.06-.41-.1-.61-.13s-.4-.04-.58-.04c-.25,0-.48.02-.68.07-.21.05-.38.11-.52.2s-.25.19-.33.31c-.08.12-.12.26-.12.41,0,.16.04.31.13.44.09.13.21.25.37.37.16.12.35.23.58.34.23.11.49.23.77.35.39.16.74.34,1.06.52.31.18.58.39.8.62s.39.5.51.8c.12.3.18.65.18,1.04,0,.55-.1,1.01-.31,1.38-.21.37-.49.67-.84.9-.36.23-.77.39-1.24.5s-.97.15-1.49.15-1.05-.05-1.53-.14-.91-.23-1.26-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266.51,110.51c-.72.35-1.65.52-2.8.52-1.5,0-2.69-.44-3.55-1.33s-1.29-2.06-1.29-3.53c0-1.57.48-2.84,1.45-3.81s2.23-1.46,3.77-1.46c.96,0,1.76.12,2.42.36v2.13c-.66-.39-1.4-.59-2.24-.59-.92,0-1.66.29-2.23.87s-.85,1.36-.85,2.35.27,1.7.8,2.27c.53.56,1.25.84,2.15.84s1.65-.21,2.37-.63v2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270.7,110.86h-2.21v-9.8h2.21v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.42,107.48v3.38h-2.21v-9.8h3.46c2.47,0,3.71,1.04,3.71,3.12,0,.98-.35,1.78-1.06,2.39-.71.61-1.66.91-2.84.91h-1.05ZM275.42,102.75v3.06h.87c1.18,0,1.76-.51,1.76-1.54s-.59-1.51-1.76-1.51h-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.93,110.86h-5.84v-9.8h2.21v8.01h3.63v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.74,110.86h-2.21v-9.8h2.21v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.06,110.86h-2.23l-4.04-6.16c-.24-.36-.4-.63-.49-.81h-.03c.04.35.05.88.05,1.59v5.39h-2.08v-9.8h2.38l3.89,5.97c.18.27.34.54.49.8h.03c-.04-.23-.05-.68-.05-1.35v-5.42h2.08v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M311.46,110.86h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.34,126.48v-2.19c.4.33.83.58,1.29.75.46.17.93.25,1.41.25.28,0,.52-.03.73-.08s.38-.12.52-.21c.14-.09.24-.19.31-.31.07-.12.1-.25.1-.39,0-.19-.05-.36-.16-.51s-.26-.29-.45-.42-.41-.25-.67-.37-.54-.24-.84-.36c-.77-.32-1.34-.71-1.71-1.17s-.56-1.02-.56-1.67c0-.51.1-.95.31-1.32.21-.37.48-.67.84-.91s.76-.41,1.23-.52c.46-.11.96-.17,1.48-.17s.96.03,1.36.09c.39.06.76.16,1.09.28v2.04c-.16-.11-.34-.21-.54-.3s-.39-.16-.6-.21c-.21-.06-.41-.1-.61-.13s-.4-.04-.58-.04c-.25,0-.48.02-.68.07-.21.05-.38.11-.52.2s-.25.19-.33.31c-.08.12-.12.26-.12.41,0,.16.04.31.13.44.09.13.21.25.37.37.16.12.35.23.58.34.23.11.49.23.77.35.39.16.74.34,1.06.52.31.18.58.39.8.62s.39.5.51.8c.12.3.18.65.18,1.04,0,.55-.1,1.01-.31,1.38-.21.37-.49.67-.84.9-.36.23-.77.39-1.24.5s-.97.15-1.49.15-1.05-.05-1.53-.14-.91-.23-1.26-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.13,123.48v3.38h-2.21v-9.8h3.46c2.47,0,3.71,1.04,3.71,3.12,0,.98-.35,1.78-1.06,2.39-.71.61-1.66.91-2.84.91h-1.05ZM255.13,118.75v3.06h.87c1.18,0,1.76-.51,1.76-1.54s-.59-1.51-1.76-1.51h-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.68,126.86h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.56,126.51c-.71.35-1.65.52-2.8.52-1.5,0-2.69-.44-3.55-1.33s-1.29-2.06-1.29-3.53c0-1.57.48-2.84,1.45-3.81s2.23-1.46,3.77-1.46c.96,0,1.76.12,2.42.36v2.13c-.66-.39-1.4-.59-2.24-.59-.92,0-1.66.29-2.23.87s-.85,1.36-.85,2.35.27,1.7.8,2.27c.53.56,1.25.84,2.15.84s1.65-.21,2.37-.63v2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.75,126.86h-2.21v-9.8h2.21v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.93,118.85h-3.46v2.41h3.18v1.79h-3.18v3.81h-2.21v-9.8h5.67v1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.03,126.86h-2.21v-9.8h2.21v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.57,126.51c-.71.35-1.65.52-2.8.52-1.5,0-2.69-.44-3.55-1.33s-1.29-2.06-1.29-3.53c0-1.57.48-2.84,1.45-3.81.97-.98,2.22-1.46,3.77-1.46.96,0,1.76.12,2.42.36v2.13c-.66-.39-1.4-.59-2.24-.59-.92,0-1.66.29-2.23.87-.56.58-.85,1.36-.85,2.35s.27,1.7.8,2.27c.53.56,1.25.84,2.15.84s1.65-.21,2.37-.63v2.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.62,142.48v-2.19c.4.33.83.58,1.29.75.46.17.93.25,1.41.25.28,0,.52-.03.73-.08s.38-.12.52-.21c.14-.09.24-.19.31-.31.07-.12.1-.25.1-.39,0-.19-.05-.36-.16-.51s-.26-.29-.45-.42-.41-.25-.67-.37-.54-.24-.84-.36c-.77-.32-1.34-.71-1.71-1.17s-.56-1.02-.56-1.67c0-.51.1-.95.31-1.32.21-.37.48-.67.84-.91s.76-.41,1.23-.52c.46-.11.96-.17,1.48-.17s.96.03,1.36.09c.39.06.76.16,1.09.28v2.04c-.16-.11-.34-.21-.54-.3s-.39-.16-.6-.21c-.21-.06-.41-.1-.61-.13s-.4-.04-.58-.04c-.25,0-.48.02-.68.07-.21.05-.38.11-.52.2s-.25.19-.33.31c-.08.12-.12.26-.12.41,0,.16.04.31.13.44.09.13.21.25.37.37.16.12.35.23.58.34.23.11.49.23.77.35.39.16.74.34,1.06.52.31.18.58.39.8.62s.39.5.51.8c.12.3.18.65.18,1.04,0,.55-.1,1.01-.31,1.38-.21.37-.49.67-.84.9-.36.23-.77.39-1.24.5s-.97.15-1.49.15-1.05-.05-1.53-.14-.91-.23-1.26-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.34,142.86h-2.79l-2.86-4.26c-.05-.08-.14-.26-.26-.54h-.03v4.8h-2.21v-9.8h2.21v4.63h.03c.05-.13.15-.31.27-.55l2.71-4.09h2.63l-3.42,4.68,3.71,5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.77,142.86h-2.21v-9.8h2.21v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.12,142.86h-5.84v-9.8h2.21v8.01h3.63v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.55,142.86h-5.84v-9.8h2.21v8.01h3.63v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.7,142.48v-2.19c.4.33.83.58,1.29.75.46.17.93.25,1.41.25.28,0,.52-.03.73-.08.21-.05.38-.12.52-.21.14-.09.24-.19.31-.31.07-.12.1-.25.1-.39,0-.19-.05-.36-.16-.51s-.26-.29-.45-.42c-.19-.13-.41-.25-.67-.37s-.54-.24-.84-.36c-.77-.32-1.34-.71-1.71-1.17s-.56-1.02-.56-1.67c0-.51.1-.95.31-1.32.21-.37.48-.67.84-.91.35-.24.76-.41,1.23-.52.46-.11.96-.17,1.48-.17s.96.03,1.36.09c.39.06.76.16,1.09.28v2.04c-.16-.11-.34-.21-.54-.3-.19-.09-.39-.16-.6-.21-.21-.06-.41-.1-.61-.13-.2-.03-.4-.04-.58-.04-.25,0-.48.02-.68.07-.21.05-.38.11-.52.2-.14.09-.25.19-.33.31-.08.12-.12.26-.12.41,0,.16.04.31.13.44.09.13.21.25.37.37.16.12.35.23.58.34.23.11.49.23.77.35.39.16.74.34,1.06.52.31.18.58.39.8.62.22.23.39.5.51.8.12.3.18.65.18,1.04,0,.55-.1,1.01-.31,1.38-.21.37-.49.67-.84.9-.36.23-.77.39-1.24.5s-.97.15-1.49.15-1.05-.05-1.53-.14-.91-.23-1.26-.41Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 273.48,
    cy: 80.48,
    r: 77.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.48,160.95c-44.38,0-80.48-36.1-80.48-80.48S229.1,0,273.48,0s80.48,36.1,80.48,80.48-36.1,80.48-80.48,80.48ZM273.48,3c-42.72,0-77.48,34.76-77.48,77.48s34.76,77.48,77.48,77.48,77.48-34.76,77.48-77.48S316.2,3,273.48,3Z"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.94,78.04h-8.79v-8.79c0-.8-.66-1.46-1.46-1.46s-1.46.66-1.46,1.46v8.79h-8.79c-.8,0-1.46.66-1.46,1.46,0,.4.16.76.43,1.03.26.26.63.43,1.03.43h8.79v8.79c0,.4.16.76.43,1.03.26.26.63.43,1.03.43.8,0,1.46-.66,1.46-1.46v-8.79h8.79c.8,0,1.46-.66,1.46-1.46s-.66-1.46-1.46-1.46Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51,193c-28.17,0-51,22.83-51,51,0-28.12,22.88-51,51-51Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M546,244c0-28.17-22.83-51-51-51,28.12,0,51,22.88,51,51Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M0,244c0,28.17,22.83,51,51,51-28.12,0-51-22.88-51-51Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M546,244c0,20.64-12.33,38.44-30,46.46v.02c17.69-8.01,30-25.8,30-46.47Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51,292c-26.47,0-48-21.53-48-48s21.53-48,48-48h444c26.47,0,48,21.53,48,48,0,18.94-11.03,35.35-27,43.15v3.3c17.67-8.02,30-25.82,30-46.46,0-28.12-22.88-51-51-51H51c-28.12,0-51,22.88-51,51s22.88,51,51,51h371.35v-3H51Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 310,
    y: 278,
    width: 92,
    height: 113,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M397,394h-82c-4.41,0-8-3.59-8-8v-103c0-4.41,3.59-8,8-8h82c4.41,0,8,3.59,8,8v103c0,4.41-3.59,8-8,8ZM315,278c-2.76,0-5,2.24-5,5v103c0,2.76,2.24,5,5,5h82c2.76,0,5-2.24,5-5v-103c0-2.76-2.24-5-5-5h-82Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sUBJECT_mATTER_expert",
    "data-name": "sUBJECT mATTER expert",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.04,295.62v-2.19c.4.33.83.58,1.29.75.46.17.93.25,1.41.25.28,0,.52-.03.73-.08.21-.05.38-.12.52-.21.14-.09.24-.19.31-.31.07-.12.1-.25.1-.39,0-.19-.05-.36-.16-.51s-.26-.29-.45-.42c-.19-.13-.41-.25-.67-.37s-.54-.24-.84-.36c-.77-.32-1.34-.71-1.71-1.17s-.56-1.02-.56-1.67c0-.51.1-.95.31-1.32.21-.37.48-.67.84-.91.35-.24.76-.41,1.23-.52.46-.11.96-.17,1.48-.17s.96.03,1.36.09c.39.06.76.16,1.09.28v2.04c-.16-.11-.34-.21-.54-.3-.19-.09-.39-.16-.6-.21-.21-.06-.41-.1-.61-.13-.2-.03-.4-.04-.58-.04-.25,0-.48.02-.68.07-.21.05-.38.11-.52.2-.14.09-.25.19-.33.31-.08.12-.12.26-.12.41,0,.16.04.31.13.44.09.13.21.25.37.37.16.12.35.23.58.34.23.11.49.23.77.35.39.16.74.34,1.06.52.31.18.58.39.8.62.22.23.39.5.51.8.12.3.18.65.18,1.04,0,.55-.1,1.01-.31,1.38-.21.37-.49.67-.84.9-.36.23-.77.39-1.24.5s-.97.15-1.49.15-1.05-.05-1.54-.14-.91-.23-1.26-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.61,291.75c0,2.94-1.37,4.42-4.12,4.42s-3.99-1.44-3.99-4.31v-5.66h2.21v5.69c0,1.59.62,2.38,1.86,2.38s1.83-.77,1.83-2.3v-5.77h2.21v5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.03,296v-9.8h3.57c1.09,0,1.93.2,2.52.6s.88.97.88,1.7c0,.53-.18.99-.54,1.39-.36.4-.81.67-1.37.83v.03c.7.09,1.25.34,1.67.77s.62.95.62,1.57c0,.9-.32,1.61-.96,2.14-.64.53-1.52.79-2.63.79h-3.77ZM348.23,287.82v2.32h.97c.46,0,.81-.11,1.08-.33.26-.22.39-.52.39-.91,0-.72-.54-1.08-1.61-1.08h-.83ZM348.23,291.79v2.58h1.2c.51,0,.91-.12,1.2-.36.29-.24.43-.56.43-.97s-.14-.7-.43-.92c-.29-.22-.68-.33-1.19-.33h-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.37,292.11c0,1.31-.3,2.32-.91,3.01s-1.49,1.05-2.64,1.05c-.52,0-.99-.09-1.43-.27v-2.07c.38.29.8.43,1.27.43,1.01,0,1.51-.75,1.51-2.24v-5.82h2.2v5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.68,296h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.55,295.65c-.71.35-1.65.52-2.8.52-1.5,0-2.69-.44-3.55-1.33s-1.29-2.06-1.29-3.53c0-1.57.48-2.84,1.45-3.81.97-.98,2.22-1.46,3.77-1.46.96,0,1.76.12,2.42.36v2.13c-.66-.39-1.4-.59-2.24-.59-.92,0-1.66.29-2.23.87-.56.58-.85,1.36-.85,2.35s.27,1.7.8,2.27c.53.56,1.25.84,2.15.84s1.65-.21,2.37-.63v2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.43,288h-2.8v8h-2.21v-8h-2.78v-1.8h7.79v1.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.82,310h-2.18v-5.87c0-.63.03-1.33.08-2.1h-.05c-.11.6-.22,1.03-.31,1.3l-2.3,6.67h-1.8l-2.34-6.6c-.06-.18-.17-.63-.31-1.37h-.06c.06.97.09,1.81.09,2.54v5.42h-1.99v-9.8h3.23l2,5.81c.16.46.28.93.35,1.4h.04c.12-.54.25-1.01.39-1.42l2-5.8h3.15v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.95,310h-2.41l-.7-2.18h-3.49l-.69,2.18h-2.39l3.57-9.8h2.62l3.49,9.8ZM347.34,306.12l-1.05-3.29c-.08-.25-.13-.54-.16-.88h-.05c-.02.29-.08.57-.17.85l-1.07,3.32h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.36,302h-2.8v8h-2.21v-8h-2.78v-1.8h7.79v1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.12,302h-2.8v8h-2.21v-8h-2.78v-1.8h7.79v1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.6,310h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.68,310h-2.54l-1.52-2.52c-.11-.19-.22-.36-.33-.51-.1-.15-.21-.28-.32-.39-.11-.11-.22-.19-.33-.25-.12-.06-.24-.08-.38-.08h-.59v3.75h-2.21v-9.8h3.5c2.38,0,3.57.89,3.57,2.67,0,.34-.05.66-.16.95-.1.29-.25.55-.44.78s-.42.43-.69.6c-.27.17-.57.3-.91.4v.03c.15.05.29.12.42.22.14.1.27.22.4.36.13.14.25.28.37.44.12.16.22.31.32.46l1.85,2.9ZM378.66,301.85v2.73h.96c.47,0,.85-.14,1.14-.41.29-.28.44-.62.44-1.03,0-.86-.51-1.29-1.54-1.29h-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.29,324h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.43,324h-2.62l-1.69-3.19c-.06-.12-.13-.34-.2-.66h-.03c-.03.15-.11.38-.23.68l-1.7,3.17h-2.63l3.12-4.9-2.86-4.9h2.69l1.4,2.94c.11.23.21.51.29.83h.03c.05-.19.16-.48.31-.85l1.56-2.91h2.46l-2.94,4.86,3.02,4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.09,320.62v3.38h-2.21v-9.8h3.46c2.47,0,3.71,1.04,3.71,3.12,0,.98-.35,1.78-1.06,2.39-.71.61-1.66.91-2.84.91h-1.05ZM351.09,315.89v3.06h.87c1.18,0,1.76-.51,1.76-1.54s-.59-1.51-1.76-1.51h-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.64,324h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.71,324h-2.54l-1.52-2.52c-.11-.19-.22-.36-.33-.51s-.21-.28-.32-.39c-.11-.11-.22-.19-.34-.25-.12-.06-.24-.08-.38-.08h-.59v3.75h-2.21v-9.8h3.5c2.38,0,3.57.89,3.57,2.67,0,.34-.05.66-.16.95-.1.29-.25.55-.44.78s-.42.43-.69.6c-.27.17-.57.3-.91.4v.03c.15.05.29.12.42.22.14.1.27.22.4.36s.25.28.37.44c.12.16.22.31.32.46l1.85,2.9ZM367.7,315.85v2.73h.96c.47,0,.85-.14,1.14-.41.29-.28.44-.62.44-1.03,0-.86-.51-1.29-1.54-1.29h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.51,316h-2.8v8h-2.21v-8h-2.78v-1.8h7.79v1.8Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SME_1_SME_2_SME_3",
    "data-name": "SME 1 SME 2 SME 3",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.49,343.11v-1.88c.34.29.71.5,1.11.64s.8.21,1.21.21c.24,0,.45-.02.62-.06s.33-.1.45-.18.21-.17.27-.27.09-.22.09-.34c0-.16-.05-.31-.14-.44s-.22-.25-.38-.36-.35-.21-.58-.32-.46-.21-.72-.31c-.66-.27-1.15-.61-1.47-1s-.48-.87-.48-1.43c0-.44.09-.81.26-1.13s.42-.57.72-.78.65-.35,1.05-.45.82-.14,1.27-.14.83.03,1.16.08.65.13.93.24v1.75c-.14-.1-.29-.18-.46-.26s-.34-.14-.51-.18-.35-.08-.52-.11-.34-.04-.5-.04c-.21,0-.41.02-.59.06s-.32.1-.45.17-.21.16-.28.27-.1.22-.1.35c0,.14.04.27.11.38s.18.22.32.32.3.2.5.29.42.19.66.3c.34.14.64.29.91.45s.5.34.69.54.34.43.44.68.15.55.15.89c0,.47-.09.86-.27,1.18s-.42.58-.72.77-.66.34-1.06.42-.83.13-1.28.13-.9-.04-1.32-.12-.78-.2-1.08-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.78,343.43h-1.87v-5.03c0-.54.02-1.14.07-1.8h-.05c-.1.52-.19.89-.26,1.11l-1.97,5.71h-1.55l-2-5.65c-.05-.15-.14-.54-.26-1.17h-.05c.05.83.08,1.55.08,2.18v4.65h-1.71v-8.4h2.77l1.72,4.98c.14.4.24.8.3,1.2h.04c.11-.46.22-.87.33-1.21l1.72-4.97h2.7v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.33,343.43h-5.04v-8.4h4.85v1.54h-2.95v1.87h2.75v1.54h-2.75v1.92h3.15v1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.1,334.84v8.59h-1.85v-6.5c-.1.09-.22.17-.36.25s-.29.15-.44.22-.32.12-.49.16-.33.08-.5.1v-1.56c.48-.14.93-.32,1.36-.54s.81-.46,1.15-.72h1.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.49,361.11v-1.88c.34.29.71.5,1.11.64s.8.21,1.21.21c.24,0,.45-.02.62-.06s.33-.1.45-.18.21-.17.27-.27.09-.22.09-.34c0-.16-.05-.31-.14-.44s-.22-.25-.38-.36-.35-.21-.58-.32-.46-.21-.72-.31c-.66-.27-1.15-.61-1.47-1s-.48-.87-.48-1.43c0-.44.09-.81.26-1.13s.42-.57.72-.78.65-.35,1.05-.45.82-.14,1.27-.14.83.03,1.16.08.65.13.93.24v1.75c-.14-.1-.29-.18-.46-.26s-.34-.14-.51-.18-.35-.08-.52-.11-.34-.04-.5-.04c-.21,0-.41.02-.59.06s-.32.1-.45.17-.21.16-.28.27-.1.22-.1.35c0,.14.04.27.11.38s.18.22.32.32.3.2.5.29.42.19.66.3c.34.14.64.29.91.45s.5.34.69.54.34.43.44.68.15.55.15.89c0,.47-.09.86-.27,1.18s-.42.58-.72.77-.66.34-1.06.42-.83.13-1.28.13-.9-.04-1.32-.12-.78-.2-1.08-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.78,361.43h-1.87v-5.03c0-.54.02-1.14.07-1.8h-.05c-.1.52-.19.89-.26,1.11l-1.97,5.71h-1.55l-2-5.65c-.05-.15-.14-.54-.26-1.17h-.05c.05.83.08,1.55.08,2.18v4.65h-1.71v-8.4h2.77l1.72,4.98c.14.4.24.8.3,1.2h.04c.11-.46.22-.87.33-1.21l1.72-4.97h2.7v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.33,361.43h-5.04v-8.4h4.85v1.54h-2.95v1.87h2.75v1.54h-2.75v1.92h3.15v1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.74,359.89h3.56v1.54h-5.59v-.63c0-.43.07-.82.22-1.16s.33-.65.54-.92.46-.51.72-.72.51-.4.74-.57c.25-.18.46-.34.65-.5s.34-.32.47-.48.22-.32.29-.48.09-.33.09-.52c0-.36-.1-.63-.3-.81s-.51-.28-.93-.28c-.72,0-1.41.29-2.07.86v-1.63c.73-.47,1.55-.71,2.47-.71.43,0,.81.06,1.14.17s.62.27.86.48.41.46.54.75.19.62.19.99c0,.39-.06.73-.18,1.03s-.28.57-.47.82-.42.47-.68.68-.53.4-.8.59c-.19.13-.37.26-.54.4s-.33.26-.46.39-.24.25-.32.37-.12.24-.12.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.49,379.11v-1.88c.34.29.71.5,1.11.64s.8.21,1.21.21c.24,0,.45-.02.62-.06s.33-.1.45-.18.21-.17.27-.27.09-.22.09-.34c0-.16-.05-.31-.14-.44s-.22-.25-.38-.36-.35-.21-.58-.32-.46-.21-.72-.31c-.66-.27-1.15-.61-1.47-1s-.48-.87-.48-1.43c0-.44.09-.81.26-1.13s.42-.57.72-.78.65-.35,1.05-.45.82-.14,1.27-.14.83.03,1.16.08.65.13.93.24v1.75c-.14-.1-.29-.18-.46-.26s-.34-.14-.51-.18-.35-.08-.52-.11-.34-.04-.5-.04c-.21,0-.41.02-.59.06s-.32.1-.45.17-.21.16-.28.27-.1.22-.1.35c0,.14.04.27.11.38s.18.22.32.32.3.2.5.29.42.19.66.3c.34.14.64.29.91.45s.5.34.69.54.34.43.44.68.15.55.15.89c0,.47-.09.86-.27,1.18s-.42.58-.72.77-.66.34-1.06.42-.83.13-1.28.13-.9-.04-1.32-.12-.78-.2-1.08-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.78,379.43h-1.87v-5.03c0-.54.02-1.14.07-1.8h-.05c-.1.52-.19.89-.26,1.11l-1.97,5.71h-1.55l-2-5.65c-.05-.15-.14-.54-.26-1.17h-.05c.05.83.08,1.55.08,2.18v4.65h-1.71v-8.4h2.77l1.72,4.98c.14.4.24.8.3,1.2h.04c.11-.46.22-.87.33-1.21l1.72-4.97h2.7v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.33,379.43h-5.04v-8.4h4.85v1.54h-2.95v1.87h2.75v1.54h-2.75v1.92h3.15v1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.91,379.15v-1.61c.56.41,1.22.62,1.97.62.47,0,.84-.1,1.1-.3s.4-.49.4-.85-.16-.66-.49-.87-.77-.3-1.34-.3h-.78v-1.42h.72c1.09,0,1.64-.36,1.64-1.09,0-.68-.42-1.03-1.26-1.03-.56,0-1.11.18-1.64.54v-1.51c.59-.3,1.28-.45,2.06-.45.86,0,1.53.19,2.01.58s.72.89.72,1.51c0,1.1-.56,1.79-1.67,2.06v.03c.59.07,1.06.29,1.41.65s.52.8.52,1.32c0,.79-.29,1.41-.86,1.86s-1.37.69-2.38.69c-.87,0-1.57-.14-2.12-.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_12",
    "data-name": "Repeat Grid 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-outline-arrow-right",
    "data-name": "Icon material-outline-arrow-right",
    d: "M334,343.82l4.19-4.19-4.19-4.19v8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-outline-arrow-right-2",
    "data-name": "Icon material-outline-arrow-right-2",
    d: "M334,361.82l4.19-4.19-4.19-4.19v8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-outline-arrow-right-3",
    "data-name": "Icon material-outline-arrow-right-3",
    d: "M334,379.82l4.19-4.19-4.19-4.19v8.39Z"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_59",
    "data-name": "Path 59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M502,392.35h-82c-3.58,0-6.5-2.78-6.5-6.2v-103.45c0-3.42,2.92-6.2,6.5-6.2h82c3.58,0,6.5,2.78,6.5,6.2v103.45c0,3.42-2.92,6.2-6.5,6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420,278c-2.76,0-5,2.11-5,4.7v103.45c0,2.6,2.24,4.7,5,4.7h82c2.76,0,5-2.11,5-4.7v-103.45c0-2.6-2.24-4.7-5-4.7h-82M420,275h82c4.41,0,8,3.46,8,7.7v103.45c0,4.25-3.59,7.7-8,7.7h-82c-4.41,0-8-3.46-8-7.7v-103.45c0-4.25,3.59-7.7,8-7.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Leader_Manager_",
    "data-name": "Leader Manager ",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.16,304h-5.84v-9.8h2.21v8.01h3.63v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M443.64,304h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M454.31,304h-2.41l-.7-2.18h-3.49l-.69,2.18h-2.39l3.57-9.8h2.62l3.49,9.8ZM450.7,300.12l-1.05-3.29c-.08-.25-.13-.54-.16-.88h-.05c-.02.29-.08.57-.17.85l-1.07,3.32h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M455.82,304v-9.8h3.47c3.48,0,5.22,1.59,5.22,4.78,0,1.53-.48,2.75-1.43,3.66s-2.22,1.37-3.8,1.37h-3.47ZM458.02,296v6.21h1.09c.96,0,1.71-.29,2.25-.86.54-.57.82-1.36.82-2.34,0-.93-.27-1.67-.81-2.2-.54-.54-1.3-.8-2.27-.8h-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M472.3,304h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M482.37,304h-2.54l-1.52-2.52c-.11-.19-.22-.36-.33-.51-.1-.15-.21-.28-.32-.39-.11-.11-.22-.19-.33-.25-.12-.06-.24-.08-.38-.08h-.59v3.75h-2.21v-9.8h3.5c2.38,0,3.57.89,3.57,2.67,0,.34-.05.66-.16.95-.1.29-.25.55-.44.78s-.42.43-.69.6c-.27.17-.57.3-.91.4v.03c.15.05.29.12.42.22.14.1.27.22.4.36.13.14.25.28.37.44.12.16.22.31.32.46l1.85,2.9ZM476.36,295.85v2.73h.96c.47,0,.85-.14,1.14-.41.29-.28.44-.62.44-1.03,0-.86-.51-1.29-1.54-1.29h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M492.96,294.2l-4.78,11.43h-1.93l4.76-11.43h1.95Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M437.17,320h-2.18v-5.87c0-.63.03-1.33.08-2.1h-.05c-.11.6-.22,1.03-.31,1.3l-2.3,6.67h-1.8l-2.34-6.6c-.06-.18-.17-.63-.31-1.37h-.06c.06.97.09,1.81.09,2.54v5.42h-1.99v-9.8h3.23l2,5.81c.16.46.28.93.35,1.4h.04c.12-.54.25-1.01.39-1.42l2-5.8h3.15v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M448.3,320h-2.41l-.7-2.18h-3.49l-.69,2.18h-2.39l3.57-9.8h2.62l3.49,9.8ZM444.69,316.12l-1.05-3.29c-.08-.25-.13-.54-.16-.88h-.05c-.02.29-.08.57-.17.85l-1.07,3.32h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M458.62,320h-2.23l-4.04-6.16c-.24-.36-.4-.63-.49-.81h-.03c.04.35.05.88.05,1.59v5.39h-2.08v-9.8h2.38l3.89,5.97c.18.27.34.54.49.8h.03c-.04-.23-.05-.68-.05-1.35v-5.42h2.08v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M469.77,320h-2.41l-.7-2.18h-3.49l-.69,2.18h-2.39l3.57-9.8h2.62l3.49,9.8ZM466.16,316.12l-1.05-3.29c-.08-.25-.13-.54-.16-.88h-.05c-.02.29-.08.57-.17.85l-1.07,3.32h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M479.18,319.34c-.96.55-2.15.83-3.57.83-1.58,0-2.82-.44-3.73-1.31-.91-.87-1.36-2.07-1.36-3.61s.5-2.8,1.49-3.77c.99-.97,2.32-1.46,3.96-1.46,1.04,0,1.96.14,2.75.43v2.07c-.76-.44-1.68-.66-2.78-.66-.92,0-1.66.3-2.24.89-.58.59-.87,1.39-.87,2.38s.26,1.79.78,2.34c.52.55,1.22.83,2.09.83.53,0,.95-.08,1.26-.23v-1.91h-1.96v-1.76h4.17v4.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M487.25,320h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M497.32,320h-2.54l-1.52-2.52c-.11-.19-.22-.36-.33-.51-.11-.15-.21-.28-.32-.39s-.22-.19-.33-.25c-.12-.06-.24-.08-.38-.08h-.59v3.75h-2.21v-9.8h3.5c2.38,0,3.57.89,3.57,2.67,0,.34-.05.66-.16.95-.11.29-.25.55-.44.78s-.42.43-.69.6c-.27.17-.57.3-.91.4v.03c.15.05.29.12.42.22.14.1.27.22.4.36.13.14.25.28.37.44.12.16.22.31.32.46l1.85,2.9ZM491.31,311.85v2.73h.96c.47,0,.85-.14,1.14-.41.29-.28.44-.62.44-1.03,0-.86-.51-1.29-1.54-1.29h-1Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "L_M_1_L_M_2_L_M_3",
    "data-name": "L M 1 L M 2 L M 3",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452.88,342.98h-5v-8.4h1.89v6.87h3.11v1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M459.11,334.57l-4.1,9.8h-1.65l4.08-9.8h1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M470.11,342.98h-1.87v-5.03c0-.54.02-1.14.07-1.8h-.05c-.1.52-.19.89-.26,1.11l-1.97,5.71h-1.55l-2-5.65c-.05-.15-.14-.54-.26-1.17h-.05c.05.83.08,1.55.08,2.18v4.65h-1.71v-8.4h2.77l1.72,4.98c.14.4.24.8.3,1.2h.04c.11-.46.22-.87.33-1.21l1.72-4.97h2.7v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M480.44,334.39v8.59h-1.85v-6.5c-.1.09-.22.17-.36.25s-.29.15-.44.22-.32.12-.49.16-.33.08-.5.1v-1.56c.48-.14.93-.32,1.36-.54s.81-.46,1.15-.72h1.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452.88,360.98h-5v-8.4h1.89v6.87h3.11v1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M459.11,352.57l-4.1,9.8h-1.65l4.08-9.8h1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M470.11,360.98h-1.87v-5.03c0-.54.02-1.14.07-1.8h-.05c-.1.52-.19.89-.26,1.11l-1.97,5.71h-1.55l-2-5.65c-.05-.15-.14-.54-.26-1.17h-.05c.05.83.08,1.55.08,2.18v4.65h-1.71v-8.4h2.77l1.72,4.98c.14.4.24.8.3,1.2h.04c.11-.46.22-.87.33-1.21l1.72-4.97h2.7v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M478.08,359.44h3.56v1.54h-5.59v-.63c0-.43.07-.82.22-1.16s.33-.65.54-.92.46-.51.72-.72.51-.4.74-.57c.25-.18.46-.34.65-.5s.34-.32.47-.48.22-.32.29-.48.09-.33.09-.52c0-.36-.1-.63-.3-.81s-.51-.28-.93-.28c-.72,0-1.41.29-2.07.86v-1.63c.73-.47,1.55-.71,2.47-.71.43,0,.81.06,1.14.17s.62.27.86.48.41.46.54.75.19.62.19.99c0,.39-.06.73-.18,1.03s-.28.57-.47.82-.42.47-.68.68-.53.4-.8.59c-.19.13-.37.26-.54.4s-.33.26-.46.39-.24.25-.32.37-.12.24-.12.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452.88,378.98h-5v-8.4h1.89v6.87h3.11v1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M459.11,370.57l-4.1,9.8h-1.65l4.08-9.8h1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M470.11,378.98h-1.87v-5.03c0-.54.02-1.14.07-1.8h-.05c-.1.52-.19.89-.26,1.11l-1.97,5.71h-1.55l-2-5.65c-.05-.15-.14-.54-.26-1.17h-.05c.05.83.08,1.55.08,2.18v4.65h-1.71v-8.4h2.77l1.72,4.98c.14.4.24.8.3,1.2h.04c.11-.46.22-.87.33-1.21l1.72-4.97h2.7v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M476.25,378.7v-1.61c.56.41,1.22.62,1.97.62.47,0,.84-.1,1.1-.3s.4-.49.4-.85-.16-.66-.49-.87-.77-.3-1.34-.3h-.78v-1.42h.72c1.09,0,1.64-.36,1.64-1.09,0-.68-.42-1.03-1.26-1.03-.56,0-1.11.18-1.64.54v-1.51c.59-.3,1.28-.45,2.06-.45.86,0,1.53.19,2.01.58s.72.89.72,1.51c0,1.1-.56,1.79-1.67,2.06v.03c.59.07,1.06.29,1.41.65s.52.8.52,1.32c0,.79-.29,1.41-.86,1.86s-1.37.69-2.38.69c-.87,0-1.57-.14-2.12-.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_12-2",
    "data-name": "Repeat Grid 12-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-outline-arrow-right-4",
    "data-name": "Icon material-outline-arrow-right-4",
    className: "cls-2",
    d: "M439,343.36l4.19-4.19-4.19-4.19v8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-outline-arrow-right-5",
    "data-name": "Icon material-outline-arrow-right-5",
    className: "cls-2",
    d: "M439,361.36l4.19-4.19-4.19-4.19v8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-outline-arrow-right-6",
    "data-name": "Icon material-outline-arrow-right-6",
    className: "cls-2",
    d: "M439,379.36l4.19-4.19-4.19-4.19v8.39Z"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_285-2",
    "data-name": "Rectangle 285-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 204,
    y: 278,
    width: 92,
    height: 113,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291,394h-82c-4.41,0-8-3.59-8-8v-103c0-4.41,3.59-8,8-8h82c4.41,0,8,3.59,8,8v103c0,4.41-3.59,8-8,8ZM209,278c-2.76,0-5,2.24-5,5v103c0,2.76,2.24,5,5,5h82c2.76,0,5-2.24,5-5v-103c0-2.76-2.24-5-5-5h-82Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Project_Manager",
    "data-name": "Project Manager",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.14,300.62v3.38h-2.21v-9.8h3.46c2.47,0,3.71,1.04,3.71,3.12,0,.98-.35,1.78-1.06,2.39-.71.61-1.66.91-2.84.91h-1.05ZM223.14,295.89v3.06h.87c1.18,0,1.76-.51,1.76-1.54s-.59-1.51-1.76-1.51h-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.03,304h-2.54l-1.52-2.52c-.11-.19-.22-.36-.33-.51s-.21-.28-.32-.39c-.11-.11-.22-.19-.33-.25-.12-.06-.24-.08-.38-.08h-.59v3.75h-2.21v-9.8h3.5c2.38,0,3.57.89,3.57,2.67,0,.34-.05.66-.16.95-.1.29-.25.55-.44.78s-.42.43-.69.6-.57.3-.91.4v.03c.15.05.29.12.42.22.14.1.27.22.4.36s.25.28.37.44c.12.16.22.31.32.46l1.85,2.9ZM232.01,295.85v2.73h.96c.47,0,.85-.14,1.14-.41.29-.28.44-.62.44-1.03,0-.86-.51-1.29-1.54-1.29h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.23,304.17c-1.4,0-2.55-.46-3.43-1.37-.88-.91-1.33-2.1-1.33-3.57,0-1.55.45-2.8,1.35-3.76s2.09-1.44,3.57-1.44c1.4,0,2.53.46,3.39,1.37s1.3,2.12,1.3,3.62-.45,2.78-1.34,3.73-2.06,1.42-3.5,1.42ZM243.33,295.93c-.77,0-1.39.29-1.85.87-.46.58-.68,1.35-.68,2.31s.23,1.74.68,2.3,1.05.85,1.79.85,1.36-.27,1.81-.82c.45-.55.67-1.31.67-2.29s-.22-1.81-.65-2.37-1.03-.85-1.78-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.94,300.11c0,1.31-.3,2.32-.91,3.01s-1.49,1.05-2.64,1.05c-.52,0-.99-.09-1.43-.27v-2.07c.38.29.8.43,1.27.43,1.01,0,1.51-.75,1.51-2.24v-5.82h2.2v5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M262.24,304h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.12,303.65c-.72.35-1.65.52-2.8.52-1.5,0-2.69-.44-3.55-1.33s-1.29-2.06-1.29-3.53c0-1.57.48-2.84,1.45-3.81s2.23-1.46,3.77-1.46c.96,0,1.76.12,2.42.36v2.13c-.66-.39-1.4-.59-2.24-.59-.92,0-1.66.29-2.23.87s-.85,1.36-.85,2.35.27,1.7.8,2.27c.53.56,1.25.84,2.15.84s1.65-.21,2.37-.63v2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280,296h-2.8v8h-2.21v-8h-2.78v-1.8h7.79v1.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.17,320h-2.18v-5.87c0-.63.03-1.33.08-2.1h-.05c-.11.6-.22,1.03-.31,1.3l-2.3,6.67h-1.8l-2.34-6.6c-.06-.18-.17-.63-.31-1.37h-.06c.06.97.09,1.81.09,2.54v5.42h-1.99v-9.8h3.23l2,5.81c.16.46.28.93.35,1.4h.04c.12-.54.25-1.01.39-1.42l2-5.8h3.15v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.3,320h-2.41l-.7-2.18h-3.49l-.69,2.18h-2.39l3.57-9.8h2.62l3.49,9.8ZM233.69,316.12l-1.05-3.29c-.08-.25-.13-.54-.16-.88h-.05c-.02.29-.08.57-.17.85l-1.07,3.32h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.62,320h-2.23l-4.04-6.16c-.24-.36-.4-.63-.49-.81h-.03c.04.35.05.88.05,1.59v5.39h-2.08v-9.8h2.38l3.89,5.97c.18.27.34.54.49.8h.03c-.04-.23-.05-.68-.05-1.35v-5.42h2.08v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M258.77,320h-2.41l-.7-2.18h-3.49l-.69,2.18h-2.39l3.57-9.8h2.62l3.49,9.8ZM255.16,316.12l-1.05-3.29c-.08-.25-.13-.54-.16-.88h-.05c-.02.29-.08.57-.17.85l-1.07,3.32h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.18,319.34c-.96.55-2.15.83-3.57.83-1.58,0-2.82-.44-3.73-1.31-.91-.87-1.36-2.07-1.36-3.61s.5-2.8,1.49-3.77,2.31-1.46,3.96-1.46c1.04,0,1.96.14,2.75.43v2.07c-.76-.44-1.68-.66-2.78-.66-.92,0-1.66.3-2.24.89-.58.59-.86,1.39-.86,2.38s.26,1.79.78,2.34,1.22.83,2.1.83c.53,0,.95-.08,1.26-.23v-1.91h-1.96v-1.76h4.17v4.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.25,320h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.32,320h-2.54l-1.52-2.52c-.11-.19-.22-.36-.33-.51-.11-.15-.21-.28-.32-.39s-.22-.19-.33-.25c-.12-.06-.24-.08-.38-.08h-.59v3.75h-2.21v-9.8h3.5c2.38,0,3.57.89,3.57,2.67,0,.34-.05.66-.16.95-.11.29-.25.55-.44.78s-.42.43-.69.6c-.27.17-.57.3-.91.4v.03c.15.05.29.12.42.22.14.1.27.22.4.36.13.14.25.28.37.44.12.16.22.31.32.46l1.85,2.9ZM280.31,311.85v2.73h.96c.47,0,.85-.14,1.14-.41.29-.28.44-.62.44-1.03,0-.86-.51-1.29-1.54-1.29h-1Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM_1_PM_2_PM_3",
    "data-name": "PM 1 PM 2 PM 3",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.77,340.08v2.89h-1.89v-8.4h2.96c2.12,0,3.18.89,3.18,2.68,0,.84-.3,1.53-.91,2.05s-1.42.78-2.43.78h-.9ZM241.77,336.03v2.62h.74c1.01,0,1.51-.44,1.51-1.32s-.5-1.29-1.51-1.29h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.42,342.98h-1.87v-5.03c0-.54.02-1.14.07-1.8h-.05c-.1.52-.19.89-.26,1.11l-1.97,5.71h-1.55l-2-5.65c-.05-.15-.14-.54-.26-1.17h-.05c.05.83.08,1.55.08,2.18v4.65h-1.71v-8.4h2.77l1.72,4.98c.14.4.24.8.3,1.2h.04c.11-.46.22-.87.33-1.21l1.72-4.97h2.7v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.76,334.39v8.59h-1.85v-6.5c-.1.09-.22.17-.36.25s-.29.15-.44.22-.32.12-.49.16-.33.08-.5.1v-1.56c.48-.14.93-.32,1.36-.54s.81-.46,1.15-.72h1.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.77,358.08v2.89h-1.89v-8.4h2.96c2.12,0,3.18.89,3.18,2.68,0,.84-.3,1.53-.91,2.05s-1.42.78-2.43.78h-.9ZM241.77,354.03v2.62h.74c1.01,0,1.51-.44,1.51-1.32s-.5-1.29-1.51-1.29h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.42,360.98h-1.87v-5.03c0-.54.02-1.14.07-1.8h-.05c-.1.52-.19.89-.26,1.11l-1.97,5.71h-1.55l-2-5.65c-.05-.15-.14-.54-.26-1.17h-.05c.05.83.08,1.55.08,2.18v4.65h-1.71v-8.4h2.77l1.72,4.98c.14.4.24.8.3,1.2h.04c.11-.46.22-.87.33-1.21l1.72-4.97h2.7v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.4,359.44h3.56v1.54h-5.59v-.63c0-.43.07-.82.22-1.16s.33-.65.54-.92.46-.51.72-.72.51-.4.74-.57c.25-.18.46-.34.65-.5s.34-.32.47-.48.22-.32.28-.48.09-.33.09-.52c0-.36-.1-.63-.3-.81s-.51-.28-.93-.28c-.72,0-1.41.29-2.07.86v-1.63c.73-.47,1.55-.71,2.47-.71.43,0,.81.06,1.15.17s.62.27.86.48.41.46.54.75.18.62.18.99c0,.39-.06.73-.18,1.03s-.28.57-.47.82-.42.47-.68.68-.53.4-.8.59c-.19.13-.37.26-.54.4s-.33.26-.46.39-.24.25-.32.37-.12.24-.12.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.77,376.08v2.89h-1.89v-8.4h2.96c2.12,0,3.18.89,3.18,2.68,0,.84-.3,1.53-.91,2.05s-1.42.78-2.43.78h-.9ZM241.77,372.03v2.62h.74c1.01,0,1.51-.44,1.51-1.32s-.5-1.29-1.51-1.29h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.42,378.98h-1.87v-5.03c0-.54.02-1.14.07-1.8h-.05c-.1.52-.19.89-.26,1.11l-1.97,5.71h-1.55l-2-5.65c-.05-.15-.14-.54-.26-1.17h-.05c.05.83.08,1.55.08,2.18v4.65h-1.71v-8.4h2.77l1.72,4.98c.14.4.24.8.3,1.2h.04c.11-.46.22-.87.33-1.21l1.72-4.97h2.7v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.57,378.7v-1.61c.56.41,1.22.62,1.97.62.47,0,.84-.1,1.1-.3s.4-.49.4-.85-.16-.66-.49-.87-.77-.3-1.34-.3h-.78v-1.42h.72c1.09,0,1.64-.36,1.64-1.09,0-.68-.42-1.03-1.26-1.03-.56,0-1.11.18-1.64.54v-1.51c.59-.3,1.28-.45,2.06-.45.86,0,1.53.19,2.01.58s.72.89.72,1.51c0,1.1-.56,1.79-1.67,2.06v.03c.59.07,1.06.29,1.41.65s.52.8.52,1.32c0,.79-.29,1.41-.86,1.86s-1.37.69-2.38.69c-.87,0-1.57-.14-2.12-.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_12-3",
    "data-name": "Repeat Grid 12-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-outline-arrow-right-7",
    "data-name": "Icon material-outline-arrow-right-7",
    className: "cls-2",
    d: "M231,343.36l4.19-4.19-4.19-4.19v8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-outline-arrow-right-8",
    "data-name": "Icon material-outline-arrow-right-8",
    className: "cls-2",
    d: "M231,361.36l4.19-4.19-4.19-4.19v8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-outline-arrow-right-9",
    "data-name": "Icon material-outline-arrow-right-9",
    className: "cls-2",
    d: "M231,379.36l4.19-4.19-4.19-4.19v8.39Z"
  })))))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M546,243.97c0,28.17-22.83,51-51,51,28.12,0,51-22.88,51-51Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M546,243.97c0-20.64-12.33-38.44-30-46.46v-.02c17.69,8.01,30,25.8,30,46.47Z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69.88,249.14h-2.23l-4.04-6.16c-.24-.36-.4-.63-.49-.81h-.03c.04.35.05.88.05,1.59v5.39h-2.08v-9.8h2.38l3.89,5.97c.18.27.34.54.49.8h.03c-.04-.23-.05-.68-.05-1.35v-5.42h2.08v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M76.5,249.31c-1.4,0-2.55-.46-3.43-1.37s-1.33-2.1-1.33-3.57c0-1.55.45-2.8,1.35-3.76s2.09-1.44,3.57-1.44c1.4,0,2.53.46,3.39,1.37s1.3,2.12,1.3,3.62-.45,2.78-1.34,3.73-2.06,1.42-3.5,1.42ZM76.59,241.07c-.77,0-1.39.29-1.85.87s-.68,1.35-.68,2.31.23,1.74.68,2.3,1.05.85,1.79.85,1.36-.27,1.81-.82.67-1.31.67-2.29-.22-1.81-.65-2.37-1.03-.85-1.78-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M91.37,239.33l-3.38,9.8h-2.5l-3.34-9.8h2.38l2.04,6.82c.11.37.18.69.2.98h.04c.03-.31.1-.64.21-1l2.03-6.79h2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M94.99,249.14h-2.21v-9.8h2.21v9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M104.49,248.79c-.72.35-1.65.52-2.8.52-1.5,0-2.69-.44-3.55-1.33s-1.29-2.06-1.29-3.53c0-1.57.48-2.84,1.45-3.81s2.23-1.46,3.77-1.46c.96,0,1.76.12,2.42.36v2.13c-.66-.39-1.4-.59-2.24-.59-.92,0-1.66.29-2.23.87s-.85,1.36-.85,2.35.27,1.7.8,2.27,1.25.84,2.15.84,1.65-.21,2.37-.63v2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M112.31,249.14h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M124.06,249.14h-5.84v-9.8h2.21v8.01h3.63v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M131.5,249.14h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M141.54,239.33l-3.38,9.8h-2.5l-3.34-9.8h2.38l2.04,6.82c.11.37.18.69.2.98h.04c.03-.31.1-.64.21-1l2.03-6.79h2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M148.83,249.14h-5.88v-9.8h5.65v1.8h-3.45v2.18h3.21v1.79h-3.21v2.24h3.67v1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M156.48,249.14h-5.84v-9.8h2.21v8.01h3.63v1.79Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerPathDiagram);
export default __webpack_public_path__ + "static/media/career-path-diagram.57f0968efb8d2ff1fc2905a54fb9676e.svg";
export { ForwardRef as ReactComponent };